var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconForVoters = function SvgIconForVoters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFEAE1",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__a)",
    fillRule: "evenodd",
    d: "M19.842 11.898c0 3.558-2.008 6.443-4.486 6.443-2.477 0-4.486-2.885-4.486-6.443 0-4.063 4.659-2.54 6.712-1.563.79.376 1.226-1.552 1.928-.003.212.454.332.975.332 1.566Zm-1.07-.979c-.465.348-1.002.51-1.58.235a11.994 11.994 0 0 0-2.294-.827c-.708-.171-1.914-.364-2.563.075-.473.32-.558.972-.558 1.496 0 1.277.292 2.624.952 3.728.469.785 1.188 1.533 2.107 1.748a2.286 2.286 0 0 0 1.04 0c.92-.215 1.639-.963 2.107-1.748.66-1.104.952-2.45.952-3.728 0-.337-.05-.665-.163-.979Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__b)",
    fillRule: "evenodd",
    d: "M18.799 7.533c.715-3.032-10.306-3.725-8.595 3.457.206-.007.454.037.744.148.618-2.998 4.737-1.63 6.634-.727.79.375 1.226-1.552 1.928-.004.106.228.19.472.246.734.305-.12.563-.167.777-.158.534-2.217.002-3.446-1.734-3.45Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__c)",
    fillRule: "evenodd",
    d: "M10.946 11.898c0-.31.027-.588.078-.835a1.913 1.913 0 0 0-.745-.148c-1.465.055-.888 2.723.826 2.69a9.114 9.114 0 0 1-.16-1.707Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__d)",
    fillRule: "evenodd",
    d: "M19.619 13.605c1.712.033 2.297-2.636.839-2.698-.214-.009-.472.038-.777.159.056.26.086.537.086.832 0 .59-.055 1.163-.16 1.707h.012Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__e)",
    fillRule: "evenodd",
    d: "m13.233 21.663 1.572-1.913-3.056-1.094-.993 1.42 2.477 1.587Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__f)",
    fillRule: "evenodd",
    d: "m17.458 29.87-.966-6.684.43-1.164.433.528 3.126-2.003c.585.228 1.171.46 1.758.691v4.18h-4.343v3.55h1.07v.901h-1.508Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__g)",
    fillRule: "evenodd",
    d: "m17.495 21.663-1.573-1.913 3.056-1.094.994 1.42-2.477 1.587Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__h)",
    fillRule: "evenodd",
    d: "m15.364 20.117 1.07 1.301-.515 1.393h-1.11l-.515-1.393 1.07-1.3Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__i)",
    fillRule: "evenodd",
    d: "m15.863 23.477.923 6.386h-2.845l.923-6.386h1Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__j)",
    fillRule: "evenodd",
    d: "m13.269 29.87.966-6.684-.43-1.164-.433.528-3.125-2.003c-1.313.511-2.633 1.045-3.949 1.535-.214.09-.385.234-.508.414-.165.241-.195.436-.23.716l-.559 6.657h8.268Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__k)",
    fillRule: "evenodd",
    d: "M30.657 25.411v-5.34h-7.75v5.34h7.75Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__l)",
    fillRule: "evenodd",
    d: "M19.634 28.969v5.672H33.93v-5.672H19.634Zm4.61 1.784c.245-.286.587-.463.967-.463s.722.177.967.463c.232.272.376.645.376 1.052 0 .407-.144.78-.376 1.051a1.268 1.268 0 0 1-.967.464c-.38 0-.722-.178-.966-.464a1.62 1.62 0 0 1-.377-1.051c0-.408.144-.78.377-1.052Zm.967.204a.611.611 0 0 0-.461.228.952.952 0 0 0-.215.62c0 .245.082.464.215.62.12.14.284.228.461.228.177 0 .34-.087.462-.229a.952.952 0 0 0 .214-.62.952.952 0 0 0-.215-.619.611.611 0 0 0-.46-.228Zm-1.643-.204a.333.333 0 0 0-.612-.26l-.702 1.646-.702-1.646a.332.332 0 1 0-.612.26l1 2.343a.332.332 0 0 0 .62.021l1.008-2.363Zm4.267.204v2.03a.333.333 0 0 0 .667 0v-2.03h.675a.333.333 0 0 0 0-.667H27.16a.333.333 0 1 0 0 .667h.675Zm2.8 1.181h1.683a.333.333 0 1 0 0-.666h-1.683v-.515h1.683a.333.333 0 0 0 0-.667h-2.016a.333.333 0 0 0-.334.333v2.363c0 .184.15.334.334.334h2.016a.333.333 0 1 0 0-.667h-1.683v-.515Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-for-voters_svg__m)",
    fillRule: "evenodd",
    d: "M18.563 26.086H35v2.217H18.563v-2.217Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__a",
    x1: 14.426,
    x2: 16.434,
    y1: 12.393,
    y2: 20.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__b",
    x1: 14.267,
    x2: 14.976,
    y1: 7.368,
    y2: 12.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__c",
    x1: 10.102,
    x2: 10.963,
    y1: 11.849,
    y2: 13.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__d",
    x1: 20.273,
    x2: 21.133,
    y1: 11.844,
    y2: 13.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__e",
    x1: 12.361,
    x2: 12.86,
    y1: 19.701,
    y2: 22.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__f",
    x1: 18.77,
    x2: 21.759,
    y1: 23.786,
    y2: 31.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__g",
    x1: 17.527,
    x2: 18.026,
    y1: 19.701,
    y2: 22.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__h",
    x1: 15.142,
    x2: 15.854,
    y1: 21.053,
    y2: 23.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__i",
    x1: 15.069,
    x2: 17.567,
    y1: 25.695,
    y2: 30.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__j",
    x1: 8.661,
    x2: 10.704,
    y1: 23.786,
    y2: 31.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__k",
    x1: 25.978,
    x2: 26.805,
    y1: 21.926,
    y2: 26.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__l",
    x1: 25.3,
    x2: 25.816,
    y1: 30.939,
    y2: 36.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-for-voters_svg__m",
    x1: 25.078,
    x2: 25.147,
    y1: 26.856,
    y2: 28.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD263"
  })))));
};
export default SvgIconForVoters;